<main>
  <loading-overlay [isLoading]="isLoading() > 0" />
  <p-toast position="bottom-right" key="br"></p-toast>

  <div class="content">
    <div class="page__title">
      <div class="page__title_container">
        <h1>{{ 'Greige_Title' | translateWF: 'Greige' }}</h1>
        <div class="page__title_buttons">
          @if (canEdit()) {
            <p-button [label]="'Common_Add' | translateWF: 'Add'" icon="pi pi-plus" (click)="goToDetails('new')" />
          }
        </div>
      </div>
    </div>
    <div class="cs-page-list-grid">
      @if (filterConfig() && showFilters()) {
        <csl-dynamic-filters [filterConfig]="filterConfig()!" [state]="filterState" />
      }

      <p-panel [header]="'Greige_Title' | translateWF: 'Greige'">
        <ng-template pTemplate="icons">
          <p-button
            [label]="(showFilters() ? 'Common_Hide_Filters' : 'Common_Show_Filters') | translateWF: (showFilters() ? 'Hide Filters' : 'Show Filters')"
            [icon]="showFilters() ? 'pi pi-filter-slash' : 'pi pi-filter'"
            (click)="showFilters.set(!showFilters())"
            variant="outlined"
            size="small"
          />
        </ng-template>
        <p-card data-variant="compact">
          <p-table [value]="listGreiges()" selectionMode="single" (onSort)="onSort($event)" [lazy]="true">
            <ng-template pTemplate="header">
              <tr class="primary__header">
                <th pSortableColumn="greigeCode">
                  {{ 'Greige_Code' | translateWF: 'Code' }}
                  <p-sortIcon field="greigeCode" />
                </th>
                <th pSortableColumn="longDescription">
                  {{ 'Greige_Description' | translateWF: 'Description' }}
                  <p-sortIcon field="longDescription" />
                </th>
                <th>
                  {{ 'Common_Status' | translateWF: 'Status' }}
                </th>
                <th>
                  {{ 'Greige_Wraps_Per_Inch' | translateWF: 'Wraps' }}
                </th>
                <th>
                  {{ 'Greige_Yarn_Loop_Length' | translateWF: 'Loop Length' }}
                </th>
                <th>
                  {{ 'Greige_Courses_Per_Inch' | translateWF: 'Courses Inch' }}
                </th>
                <th></th>
              </tr>
            </ng-template>

            <ng-template pTemplate="body" let-rowData let-index="rowIndex">
              @let greige = getRowData(rowData);
              <tr>
                <td class="max-w-[12.5rem] truncate">
                  <a (click)="goToDetails(greige.id)">
                    {{ greige.greigeCode }}
                  </a>
                </td>
                <td>{{ greige.longDescription }}</td>
                <td>{{ statuses()[greige.status] | pascalToNormalCase }}</td>
                <td>{{ greige.wrapsPerInch }}</td>
                <td>{{ getLoopLengthsDisplay(greige) }}</td>
                <td>{{ greige.coursesPerInch }}</td>
                <td class="!text-end">
                  <p-button icon="pi pi-trash" variant="outlined" (click)="deletePopup($event, greige)" [disabled]="!canDelete(greige)" />
                </td>
              </tr>
            </ng-template>
            <ng-template pTemplate="emptymessage">
              <tr>
                <td colspan="7">
                  {{ 'Greige_Not_Found' | translateWF: 'Greiges not found' }}
                </td>
              </tr>
            </ng-template>
          </p-table>

          <p-paginator
            [rows]="pageSize()"
            [totalRecords]="totalRecords()"
            [first]="(currentPage() - 1) * pageSize()"
            (onPageChange)="onPageChange($event)"
            [rowsPerPageOptions]="[15, 25, 50]"
            class="mt-4"
          />
        </p-card>
      </p-panel>
    </div>
  </div>
  <p-confirmdialog key="deleteGreige" />
</main>
